<template>
  <div>
    <v-card>
      <v-card-title class="text-h6 text-uppercase font-weight-regular py-2 my-2 panelheader">
        Composizione Treno Partenza
      </v-card-title>
      <v-card-text>
        <v-simple-table class="py-1 ma-1">
          <template v-slot:default>
            <thead>
              <tr>
                  <th class="text-body-1 text-left text-uppercase font-weight-regular header">Azioni</th>
                  <th class="text-body-1 text-left text-uppercase font-weight-regular header">Codice viaggio</th>
                  <th class="text-body-1 text-left text-uppercase font-weight-regular header">Destinazione</th>
                  <th class="text-body-1 text-left text-uppercase font-weight-regular header">Eta</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="viaggio in viaggi" :key="viaggio.convoglioId">
                  <td class="text-body-1 text-left font-weight-regular">
                      <v-btn  
                        elevation="1"
                        rounded
                        class="text-center text-body-1 blue lighten-2"
                        @click="goToComposizione(viaggio)"
                        > 
                    <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </td>
                  <td class="text-body-1 text-left font-weight-regular">{{ viaggio.codice}}</td>
                  <td class="text-body-1 text-left font-weight-regular">{{ viaggio.nodoPartenza.codice}}</td>
                  <td class="text-body-1 text-left font-weight-regular">{{ viaggio.eta}}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <v-divider/>
      </v-card-text>
    </v-card>

    </div>
</template>

<script>
import ToastMixin from '../../mixins/ToastMixin';
import FormatsMixins from "../../mixins/FormatsMixins";

export default {
  name: "Manovre",
  data() {
    return { 
        viaggi: [],
      }
  },
  mixins: [ToastMixin, FormatsMixins],
  mounted() {
    this.retrieveData();
  },
  computed: {
    railsPark() {
    }
  },
  methods: {
    goToComposizione(viaggio){
       this.$router.push({
          path: "/rails/manovre/ComposizioneTrenoPartenza/" + viaggio.id,
        });
    },
    async retrieveData() {
      this.viaggi = await this.$api.trainData.getViaggiPartenzaPresenti();
    },
   }
}
</script>

<style scoped>

</style>
